<app-header></app-header>
<div class="wrapper">
  <!-- <app-poster-simmer *ngIf="shimmerStatus.poster"></app-poster-simmer>
  *ngIf="!shimmerStatus.poster && !moreBrowserStatus" -->
  <section class="video-detail mb-4 gray-bg">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6">
          <h3 class="top-head">Now Playing</h3>
          <div class="section-head mb-3">
            <h2>What Is A Stock Exchange?</h2>
          </div>
          <app-vjs-player
            *ngIf="loading_player && videoDetail.videoStatus"
            [scrollStatus]="scrollPosition"
            (playerStatus)="videoStatus($event)"
            [options]="{
              autoplay: false,
              aspectRatio: '16:9',
              controls: true,
              loop: false,
              poster: thumbnails,
              sources: [
                {
                  src: output_url,
                  type: 'application/x-mpegURL'
                }
              ],
              videoDetail: videoDetail,
              redirectUrl: redirectUrl,
              controlBar: {
                pictureInPictureToggle: true
              }
            }"
          >
          </app-vjs-player>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          &nbsp;
          <br/>
          &nbsp;
          <div class="section-head mb-3">
            <h2>Content</h2>
          </div>
          <div class="audio-list-box">
            <a
              href="javascript:void()"
              class="audio-list"
              *ngFor="let number of [0, 1, 2, 3, 4]"
            >
              <div class="d-flex align-items-center">
                <div class="poster-img">
                  <div class="audio-img ratio-1-1">
                    <img src="assets/images/audio-img.jpg" />
                  </div>
                </div>
                <div>
                  <h5>What Is A Stock Exchange?</h5>
                  <p class="mb-0 text-secondary">1 month ago</p>
                </div>
              </div>
              <span class="text-secondary"> 25:05 </span>
            </a>
            <div class="nav-btn">
              <a href="javascript:void()" class="">
                <span class="mdi mdi-chevron-up"> </span>
              </a>
              <a href="javascript:void()" class="">
                <span class="mdi mdi-chevron-down"> </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-grid-simmer
    class="search-page"
    *ngIf="shimmerStatus.relatedvideo"
  ></app-grid-simmer>
  <section
    class="related-search"
    #vcontent
    [hidden]="shimmerStatus.relatedvideo"
  >
    <div class="container" *ngIf="!shimmerStatus.relatedvideo">
      <div class="section-head col-12">
        <h2>{{ "VIDEO_DETAIL.RELATED_VIDEOS" | translate }}</h2>
      </div>
      <div class="row custome-set" *ngIf="reletedShows?.length > 0">
        <div class="series-box" *ngFor="let show of reletedShows">
          <app-grid [data]="show" [gridType]="'landscape'"></app-grid>
        </div>
      </div>
      <div class="record-not-available" *ngIf="reletedShows?.length == 0">
        <div class="text-center">
          <img src="assets/images/no-recoard-playlist.png" />
          <p class="no-recored-content text-secondary">{{ "RECORD_NOT_FOUND" | translate }}</p>
        </div>
      </div>
    </div>
  </section>
</div>
<app-footer></app-footer>
